import spriteSource from './tokens/ships.svg?raw';

/** The <symbol>s of the sprite, without the wrapping <svg> element. */
const symbols = spriteSource.replace(/^[\s\S]*?<svg[^>]*>/, '').replace(/<\/svg>\s*$/, '');

/**
 * Inline SVG sprite with every vector ship token as a <symbol>, plus the blur for the soft
 * shadow under raster tokens. Mount once per page that renders <ShipToken>;
 * tokens reference it with <use href="#ship-…">. Inline (not an external file) so
 * --nation-color inherits into the symbols and tokens work offline and in tests.
 */
export function ShipSprite() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="0"
      height="0"
      style={{ position: 'absolute', overflow: 'hidden' }}
    >
      <defs>
        <filter id="ship-shadow-blur" x="-20%" y="-100%" width="140%" height="300%">
          <feGaussianBlur stdDeviation="0.9" />
        </filter>
      </defs>
      <g dangerouslySetInnerHTML={{ __html: symbols }} />
    </svg>
  );
}
